import React from "react";

interface Breadcrumb {
  name?: string;
  slug: string;
}

interface NavCrumbsProps {
  breadcrumbs?: Breadcrumb[];
}

export default function NavCrumbs({ breadcrumbs = [] }: NavCrumbsProps) {
  return (
    <nav aria-label="breadcrumb" className="pl-3 ml-3">
      <ol className="breadcrumb">
        {breadcrumbs.map((item, index) => {
          const displayName = item.name
            ?.split(" > ")
            .map((segment, idx) => <span key={idx}>{segment}</span>);
          return index === breadcrumbs.length - 1 ? (
            <li
              key={String(index)}
              className="breadcrumb-item active"
              aria-current="page"
              style={{ fontWeight: 600, fontSize: "14px" }}
            >
              {displayName}
            </li>
          ) : (
            <li key={String(index)} className="breadcrumb-item">
              <a href="#" style={{ textDecoration: "none", color: "inherit" }}>
                {displayName}
              </a>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
